<div class="modalPlans">
    <div class="contenidoModal">
      <div class="header">
        <h2 class="titleCambio">Cambio de Plan</h2>
        <img src="/assets/icono/equis.svg" class="cerrar mr-2" (click)="closeModal()" alt=""/>
      </div>
      <div>
          <img src="{{imagen}}" class="imagenFondo" alt=""/>
      </div>
      <div class="bajada">
        <div class="descripcionPlan">
          <img src="/assets/icono-plans/{{iconplan}}" class="iconoPlan" alt=""/>
          <h2 class=" titlePlan mt-2" >{{titleplan}}</h2>
          <div class="descripcion" [innerHTML]="description"></div>
        </div>
        <div class="proceso">
            <span class="title2">¿Cómo es el proceso?</span>
            <div class="descripProceso mt-2"
             [innerHTML]= "process"></div>  
        </div> 
        <div class="select-beneficiario"*ngIf="miplan === 4 && idplan === 3">
      
          <span class="title2">Selecciona el beneficiario para este plan</span>
            <mat-form-field>
              <mat-select 
              placeholder="Seleccionar"
              [formControl]="beneficiarios" 
              required> 
                <mat-option *ngFor="let mami of cargasSap " [value]="mami.rut">
                  {{mami.nombres}} {{mami.apellidoPaterno}}
                </mat-option>
              </mat-select>
             
            </mat-form-field> 
        </div>
      <div class="boxBlue">
       <img src="/assets/icono-plans/circlealerta.svg" alt="alert" class="imgalert">
       <span class="textAlarma">Ten en cuenta que una vez que te cambies a este plan deberás permanecer en él un mínimo de <strong>6 meses</strong> antes de volver a cambiarte.</span>
      </div>
    </div>
      <div class="botones">
        <button class="cancelar" (click)="closeModal()">Cancelar</button>
        <button class ="cambiarme"
        type="submit"
        (click)="successView()"     
        >Cambiarme a {{titleplan}}</button>
      </div>
 </div>
</div>
<div *ngIf="openModalAlertDonwgrade">
  <app-modal-alert
          [mensaje]="mensajeModal"
          [icono]="iconoModal"
          [cambioAplanDuo]="cambioAplanDuo"
          (closeModalPlan)="closeModalAlert($event)"
          (enviarSolicitud)="solicitaCambioPlan($event)">
          </app-modal-alert>
</div>
<div *ngIf="spinner">
  <div class="loadingSpinner">
    <div class="contenidoSpinner">
        <mat-spinner></mat-spinner>
    </div>
</div>
</div>

